import React from 'react'
import { useIntl } from 'react-intl'

import { HouseNightlyTripGlobalFieldProps } from '../form-container/HouseNightlyTripGlobalFormContainer'
import { ControlledSwitchField } from '../../../../../../../forms'

export const HouseNightlyTripGlobalIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseNightlyTripGlobalFieldProps, 'currencyArea'>) => {
  const intl = useIntl()
  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: 'Acceptez-vous les séjours avec nuitée ?',
        id: 'ui.HouseNightlyTripGlobalIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
